import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const ETabStatuses = {
	status: 'status',
	exist: 'exist',
} as const;

export const ECommonRequestStatusesForAssetRequest = {
	pending: 'PENDING',
	inProgress: 'IN_PROGRESS',
	allApproved: 'ALL_APPROVED',
	partlyApproved: 'PARTLY_APPROVED',
	allDisapproved: 'ALL_DISAPPROVED',
	updated: 'UPDATED',
	sentForAcceptance: 'SENT_FOR_ACCEPTANCE',
	sentForRevision: 'SENT_FOR_REVISION',
	accepted: 'ACCEPTED',
	contract: 'CONTRACT',
	done: 'DONE',
	declined: 'DECLINED',
	cancelled: 'CANCELLED',
	ended: 'ENDED',
} as const;

export const ERequestType = {
	errorReport: 'ERROR_REPORT',
	interest: 'INTEREST',
	question: 'QUESTION',
	reservation: 'RESERVATION',
} as const;

export const ERequestItemChanges = {
	changedDates: 'Changed dates',
	proposedAsset: 'Proposed asset',
} as const;

export const ERequestItemChangesAcceptance = {
	approved: 'Approved',
	pending: 'Pending',
	refused: 'Refused',
} as const;

export const ERequestItemApprovalStatuses = {
	pending: 'PENDING',
	approved: 'APPROVED',
	inProgress: 'IN_PROGRESS',
	disapproved: 'DISAPPROVED',
} as const;

export const EAssetAcquiredStatuses = {
	current: 'CURRENT',
	past: 'PAST',
	future: 'FUTURE',
	all: 'ALL',
} as const;

export const EAssetAcquiredStatusesLabels = {
	current: 'Current',
	past: 'Past',
	future: 'Future',
	all: 'All',
} as const;

export const EAssetRentStatuses = {
	active: 'ACTIVE',
	inactive: 'INACTIVE',
} as const;

export type TTabStatuses = TValueOfStringRecord<typeof ETabStatuses>
export type TCommonRequestStatusesForAssetRequest = TValueOfStringRecord<typeof ECommonRequestStatusesForAssetRequest>
export type TRequestType = TValueOfStringRecord<typeof ERequestType>
export type TRequestItemChanges = TValueOfStringRecord<typeof ERequestItemChanges>
export type TRequestItemChangesAcceptance = TValueOfStringRecord<typeof ERequestItemChangesAcceptance>
export type TRequestItemApprovalStatuses = TValueOfStringRecord<typeof ERequestItemApprovalStatuses>
export type TAssetAcquiredStatuses = TValueOfStringRecord<typeof EAssetAcquiredStatuses>
export type TAssetAcquiredStatusesLabels = TValueOfStringRecord<typeof EAssetAcquiredStatusesLabels>
export type TAssetRentStatuses = TValueOfStringRecord<typeof EAssetRentStatuses>
